module.exports = __webpack_public_path__ + "static/img/logo-moji-kidstthink.9b8fedf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-moji-kidstthink.svg
// module id = A0fK
// module chunks = 1